import { render, staticRenderFns } from "./PromotionInformation.vue?vue&type=template&id=2033b179&scoped=true&"
import script from "./PromotionInformation.vue?vue&type=script&lang=js&"
export * from "./PromotionInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2033b179",
  null
  
)

export default component.exports